@let title =
    "complexConditions." + (dialogData.isTransitional ? "transitionCondition" : "conditionalPrintout") + ".title"
        | translate;
<cipo-dialog-header [title]="title" testId="add-edit-complex-condition-dialog-title" />
<mat-dialog-content fxLayout="column">
    <div>
        <div fxFlexAlign="end" class="m-t">
            <cipo-select data-testid="add-edit-complex-condition-select-value" [control]="control()" />
        </div>
        <div fxLayout="row" fxLayoutAlign="end">
            @if (dialogData.isTransitional) {
                <button
                    data-testid="add-edit-complex-condition-add-start-screen-condition-button"
                    mat-flat-button
                    [title]="'general.table.addNew' | translate"
                    (click)="onAddStartScreenCondition()">
                    <mat-icon>add</mat-icon>
                    {{ "complexConditions.general.addStartScreenCondition" | translate }}
                </button>
            }
            <button
                data-testid="add-edit-complex-condition-add-field-condition"
                mat-flat-button
                [title]="'general.table.addNew' | translate"
                (click)="onAddFieldCondition()">
                <mat-icon>add</mat-icon>
                {{ "complexConditions.general.addFieldCondition" | translate }}
            </button>
        </div>
        <ng-container>
            <cipo-field-condition
                [fieldCondition]="fieldConditions()"
                [operators]="dialogData.operators"
                [fieldDict]="dialogData.fieldDict"
                (conditionsChanged)="onFieldConditionsChanged($event)"
                (fieldConditionsDirty)="onFieldConditionsDirty($event)"
                (fieldConditionsAllChanged)="onFieldConditionsAllChanged($event)"></cipo-field-condition>
        </ng-container>

        <ng-container>
            <cipo-start-screen-condition
                [screenConditions]="screenConditions()"
                [operators]="dialogData.operators"
                (conditionsChanged)="onScreenConditionsChanged($event)"
                (screenConditionsAllChanged)="onScreenConditionsAllChanged($event)"
                (screenConditionsDirty)="onScreenConditionsDirty($event)"></cipo-start-screen-condition>
        </ng-container>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" [ngClass]="{ 'cipo-bg--warn-400': showDiscardChanges() }">
    <button data-testid="add-edit-complex-condition-cancel-button" mat-button mat-dialog-close class="m-r-md">
        {{ "general.cancel" | translate }}
    </button>
    @if (showDiscardChanges()) {
        <button
            data-testid="add-edit-complex-condition-discard-changes-button"
            class="m-r-md"
            mat-button
            (click)="discardChanges()">
            {{ "general.discard" | translate }}
        </button>
    }
    <cipo-save-button
        data-testid="add-edit-complex-condition-save-button"
        [type]="SAVE_BUTTON_TYPE.SaveAndClose"
        [disable]="!isSaveEnabled()"
        (saveEvent)="save($event)"></cipo-save-button>
</mat-dialog-actions>
